import './locales/i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';
import { scrubPii } from './utils/sentryPiiScrubber';

// Sentry init (Phase 5.2) — only when VITE_SENTRY_DSN is set; otherwise a
// silent no-op so dev / staging without an observability backend still boots.
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
if (SENTRY_DSN) {
  try {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.1,
      beforeSend(event) {
        return scrubPii(event);
      },
      beforeBreadcrumb(breadcrumb) {
        return scrubPii(breadcrumb);
      },
    });
  } catch (err) {
    console.warn('[Sentry] init failed:', err?.message);
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
